// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RKkB6MQKXgKwXszRP6sj{border-radius:0 !important}.RKkB6MQKXgKwXszRP6sj.LffDU1MUMngp80GHT9Ps{height:25px !important;width:110px !important}`, "",{"version":3,"sources":["webpack://./src/components/cards/defaults/ItemHorizontalCard/components/CardButton/styles.module.sass"],"names":[],"mappings":"AAAA,sBACE,0BAAA,CACA,2CACE,sBAAA,CACA,sBAAA","sourcesContent":[".button\n  border-radius: 0 !important\n  &.cardAsLink\n    height: 25px !important\n    width: 110px !important\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `RKkB6MQKXgKwXszRP6sj`,
	"cardAsLink": `LffDU1MUMngp80GHT9Ps`
};
export default ___CSS_LOADER_EXPORT___;
